import classNames from "classnames";
import { OptionTemplate } from "shared/api/middleware-api-client";
import Icon, { IconTypes } from "shared/ui/icon";

type ProfielSelectorItemProps = {
  doorLayout: OptionTemplate;
  onChangeLayout: (layout: OptionTemplate) => void;
  imageSource: string;
  isActive: boolean;
};

export const ProfielSelectorItem = ({
  doorLayout,
  onChangeLayout,
  imageSource,
  isActive,
}: ProfielSelectorItemProps) => {
  return (
    <div
      key={`layout-${doorLayout.id}`}
      className="gg-flex gg-h-full gg-flex-col"
    >
      <button
        onClick={() => onChangeLayout(doorLayout)}
        data-testid={`door-layout-option-${doorLayout.code}`}
        className={classNames(
          "gg-relative gg-grid gg-aspect-square gg-w-24 gg-cursor-pointer gg-place-items-center",
        )}
      >
        <img
          alt={doorLayout.name}
          src={imageSource}
          className={classNames(
            "gg-aspect-square gg-w-24 gg-cursor-pointer gg-rounded gg-border gg-object-cover gg-object-center gg-text-left gg-transition gg-duration-300 gg-ease-in-out hover:gg-scale-[1.015] hover:gg-border-[#9493A3]",

            {
              "gg-border-[#9493A3] gg-bg-[#fff]": isActive,
              "gg-border-[#EAE9ED] gg-bg-white": !isActive,
            },
          )}
        />
        {isActive && (
          <Icon
            name={IconTypes.WHITE_CHECK}
            className={`gg-absolute -gg-top-2.5 gg-left-full gg-z-10 gg-aspect-square gg-w-5 -gg-translate-x-2.5 gg-rounded-full gg-bg-green-500 gg-p-1.5`}
          />
        )}
      </button>

      <h2 className="gg-mt-1 gg-text-xs gg-font-semibold gg-uppercase gg-leading-4 gg-tracking-wide gg-text-[#292747]">
        {doorLayout.name}
      </h2>
    </div>
  );
};
